





















import Vue, { PropOptions } from 'vue';

export type ColumnCardItem = Blok & {
  headline: string;
  description: string;
  descriptionLink?: string;
  button: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<ColumnCardItem>,
  },
});
